import { OrderStatusEnum as OrderStatus } from '@trybeapp/sdk'

export const STATUS_CONFIRMED = 'confirmed'

/**
 * @deprecated
 * @see {import('@trybeapp/sdk').OrderStatusEnum.Submitted}
 */
export const STATUS_SUBMITTED = OrderStatus.Submitted

/**
 * @deprecated
 * @see {import('@trybeapp/sdk').OrderStatusEnum.Settled}
 */
export const STATUS_SETTLED = OrderStatus.Settled

/**
 * @deprecated
 * @see {import('@trybeapp/sdk').OrderStatusEnum.InProgress}
 */
export const STATUS_IN_PROGRESS = OrderStatus.InProgress
export const STATUS_RESERVED = 'reserved'
export const STATUS_PENDING_CONFIRMATION = 'pending_confirmation'
export const STATUS_RESERVATION_EXPIRED = 'reservation_expired'

/**
 * @deprecated
 * @see {import('@trybeapp/sdk').OrderStatusEnum.New}
 */
export const STATUS_NEW = OrderStatus.New

/**
 * @deprecated
 * @see {import('@trybeapp/sdk').OrderStatusEnum.Cancelled}
 */
export const STATUS_CANCELLED = OrderStatus.Cancelled
export const STATUS_WAITLISTED = 'waitlisted'

/**
 * @deprecated
 * @see {import('@trybeapp/sdk').OrderStatusEnum.NoShow}
 */
export const STATUS_NO_SHOW = OrderStatus.NoShow

export const ORDER_STATUSES = [
  {
    value: OrderStatus.New,
    label: 'New',
  },
  {
    value: OrderStatus.NoShow,
    label: 'No show',
  },
  {
    value: OrderStatus.InProgress,
    label: 'In progress',
  },
  {
    value: OrderStatus.Submitted,
    label: 'Submitted',
  },
  {
    value: OrderStatus.Settled,
    label: 'Settled',
  },
  {
    value: OrderStatus.Cancelled,
    label: 'Cancelled',
  },
]

export const FINALISED_ORDER_STATUSES = [
  OrderStatus.NoShow,
  OrderStatus.Cancelled,
  OrderStatus.Settled,
]
